import React from 'react';

import ScreenWidget from './ScreenWidget';

export const withScreenWidget =
  ({ title, name, reducer, storage, description, filters, actions }) =>
  (BaseComponent) =>
  ({
    id,
    initialState,
    parentState,
    subTitle,
    onSave,
    onClose,
    globalPeriod,
    onCollapse,
    editable,
    collapsed,
    tooltipPosStrategy,
    width,
    affix,
    active,
  }) => {
    return React.cloneElement(
      storage,
      {
        id: id,
        title: subTitle,
        preset: initialState,
        parent: parentState,
        onSave,
      },
      <ScreenWidget
        title={title}
        name={name}
        reducer={reducer}
        subTitle={subTitle}
        description={description}
        filters={filters}
        actions={actions}
        onClose={onClose}
        globalPeriod={globalPeriod}
        onCollapse={onCollapse}
        editable={editable}
        collapsed={collapsed}
        affix={affix}
        active={active}
      >
        {(screenProps) => (
          <BaseComponent
            width={width}
            tooltipPosStrategy={tooltipPosStrategy}
            collapsed={collapsed}
            {...screenProps}
          />
        )}
      </ScreenWidget>
    );
  };

export default withScreenWidget;
